import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API, timeout: 20000 });

export async function fetchPackages() {
  const r = await api.get("/catalog/packages");
  return r.data;
}

export async function fetchAssumptions() {
  const r = await api.get("/catalog/assumptions");
  return r.data;
}

export async function postSimulate(input) {
  const r = await api.post("/simulate", input);
  return r.data;
}

export async function postEstimate(payload) {
  const r = await api.post("/configurator/estimate", payload);
  return r.data;
}

export async function createLead(payload) {
  const r = await api.post("/leads", payload);
  return r.data;
}
